/**
 * @file: Region.
 * @authors: fjxhx.
 * @createDate: 2022.
 * @Description: 区域信息
 */
import request from '@/utils/request'

/**
 * 区域负责人配置详情（ndj）
 * @author: fjxhx
 * @createDate: 2022
 * @param data {Object} 参数
 */
export function regionDetailInfoGet(data) {
  return request({
    type: 'biz',
    url: 'region/detail/info/get',
    method: 'post',
    data
  })
}

/**
 * 编辑区域负责人（ndj）
 * @author: fjxhx
 * @createDate: 2022
 * @param data {Object} 参数
 */
export function regionInfoUpdate(data) {
  return request({
    type: 'biz',
    url: 'region/info/update',
    method: 'post',
    data
  })
}

/**
 * 根据食堂编号获取区域信息（ndj）
 * @author: fjxhx
 * @createDate: 2022
 * @param data {Object} 参数
 */
export function regionListGet(data) {
  return request({
    type: 'biz',
    url: 'region/list/get',
    method: 'post',
    data
  })
}

/**
 * 区域负责人配置列表（ndj）
 * @author: fjxhx
 * @createDate: 2022
 * @param data {Object} 参数
 */
export function regionListInfoGet(data) {
  return request({
    type: 'biz',
    url: 'region/list/info/get',
    method: 'post',
    data
  })
}

/**
 * 获取校方区域列表（下拉框）（wzp）
 * @author: fjxhx
 * @createDate: 2022
 * @param data {Object} 参数
 */
export function regionNoconditionListGet(data) {
  return request({
    type: 'biz',
    url: 'region/nocondition/list/get',
    method: 'post',
    data
  })
}

/**
 * 根据食堂编号获取区域列表（下拉框）（ndj）
 * @author: fjxhx
 * @createDate: 2022
 * @param data {Object} 参数
 */
export function regionSelectListGet(data) {
  return request({
    type: 'biz',
    url: 'region/select/list/get',
    method: 'post',
    data
  })
}

/**
 * 获取仓库区负责人（ndj）
 * @author: fjxhx
 * @createDate: 2022
 * @param data {Object} 参数
 */
export function regionStorageInfoGet(data) {
  return request({
    type: 'biz',
    url: 'region/storage/info/get',
    method: 'post',
    data
  })
}



// WEBPACK FOOTER //
// ./src/api/Region.js